import React from 'react';
import {
    Route,
    Switch
} from 'react-router-dom'
import { injectIntl } from 'react-intl';
import Main from './Main';
import Help from './Help';
import RunlaiPrvacy from './RunlaiPrvacy';
import ZhongxPrvacy from './ZhongxPrvacy';
import FaultList from './FaultList';
import FaultListzx from './FaultListzx';
import Error1 from './Error1';
import Error2 from './Error2';
import Error3 from './Error3';
import Error4 from './Error4';
import Error5 from './Error5';
import Error11 from './Error11';
import Error22 from './Error22';
import Error33 from './Error33';
import Error44 from './Error44';
import Error55 from './Error55';
import { Setting, descFunc } from '../TimerSceneSiriSetting';

export default injectIntl(class extends React.PureComponent {

    desc = cmd => {
        const { formatMessage } = this.props.intl;
        return descFunc(cmd, formatMessage)
    };

    render() {
        return (
            <Switch location={this.props.location} history={this.props.history} level={1} >
                <Route path="/help" render={props =>
                    <Help {...props} />
                } />
                <Route path="/runlai" render={props =>
                    <RunlaiPrvacy {...props} />
                } />
                <Route path="/zhongx" render={props =>
                    <ZhongxPrvacy {...props} />
                } />
                <Route path="/falut" render={props =>
                    <FaultList {...props} />
                } />
                <Route path="/falutzx" render={props =>
                    <FaultListzx {...props} />
                } />
                <Route path="/error1" render={props =>
                    <Error1 {...props}  />
                } />
                <Route path="/error2" render={props =>
                    <Error2 {...props} />
                } />
                <Route path="/error3" render={props =>
                    <Error3 {...props} />
                } />
                <Route path="/error4" render={props =>
                    <Error4 {...props} />
                } />
                <Route path="/error5" render={props =>
                    <Error5 {...props} />
                } />
                  <Route path="/error11" render={props =>
                    <Error11 {...props}  />
                } />
                <Route path="/error22" render={props =>
                    <Error22 {...props} />
                } />
                <Route path="/error33" render={props =>
                    <Error33 {...props} />
                } />
                <Route path="/error44" render={props =>
                    <Error44 {...props} />
                } />
                <Route path="/error55" render={props =>
                    <Error55 {...props} />
                } />
                <Route path="/" render={props =>
                    <Main {...props} desc={this.desc} />
                } />
            </Switch>
        )
    }

})